import { useEffect, useState } from "react";
import { Button, ChevronUp } from "~/design-system/components";

export function ToTopButton() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 100);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (!isVisible) {
    return null;
  }

  return (
    <Button
      className="bg-primary-light animate-fade fixed bottom-10 z-30 hidden h-12 w-12 items-center justify-center rounded-full border p-0 lg:flex lg:h-16 lg:w-16 ltr:right-10 rtl:left-10"
      onClick={handleScrollToTop}
    >
      <ChevronUp />
    </Button>
  );
}
